import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { waLink } from "../lib/api";

export default function Contact() {
  return (
    <div className="container-pad mx-auto max-w-[1100px] py-16 md:py-24" data-testid="contact-page">
      <span className="label-eyebrow">Contact</span>
      <h1 className="mt-3 text-4xl sm:text-5xl font-display font-medium tracking-tighter text-[#121C17]">We're a chat away.</h1>
      <p className="mt-4 text-[#5C6661] max-w-2xl">Pick the medium you prefer. We typically reply on WhatsApp within 10 minutes during business hours (Mon–Sat, 9 AM – 8 PM IST).</p>

      <div className="mt-12 grid md:grid-cols-3 gap-4">
        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="bento-card p-7 hover:border-[#25D366]">
          <div className="w-10 h-10 rounded-xl bg-[#25D366]/10 grid place-items-center text-[#25D366]">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654z"/></svg>
          </div>
          <h3 className="mt-5 font-display font-medium text-lg text-[#121C17]">WhatsApp</h3>
          <p className="mt-1 text-sm text-[#5C6661]">+91 99999 99999</p>
        </a>

        <a href="tel:+919999999999" data-testid="contact-phone" className="bento-card p-7 hover:border-[#1E4D3B]">
          <div className="w-10 h-10 rounded-xl bg-[#1E4D3B]/10 grid place-items-center text-[#1E4D3B]"><Phone size={20} /></div>
          <h3 className="mt-5 font-display font-medium text-lg text-[#121C17]">Phone</h3>
          <p className="mt-1 text-sm text-[#5C6661]">+91 99999 99999</p>
        </a>

        <a href="mailto:hello@finsahayak.com" data-testid="contact-email" className="bento-card p-7 hover:border-[#D17B5D]">
          <div className="w-10 h-10 rounded-xl bg-[#D17B5D]/10 grid place-items-center text-[#D17B5D]"><Mail size={20} /></div>
          <h3 className="mt-5 font-display font-medium text-lg text-[#121C17]">Email</h3>
          <p className="mt-1 text-sm text-[#5C6661]">hello@finsahayak.com</p>
        </a>
      </div>

      <div className="mt-10 bento-card p-7 flex items-start gap-4">
        <MapPin size={20} className="text-[#1E4D3B] mt-1" />
        <div>
          <h3 className="font-display font-medium text-lg text-[#121C17]">Office</h3>
          <p className="text-sm text-[#5C6661] mt-1">2nd Floor, Embassy Edge, Bellandur, Bengaluru, Karnataka 560103</p>
        </div>
      </div>
    </div>
  );
}
